<template>
  <div class='updatePwd'>
        <div class="login_box">
        <div class="login_logo_box">
            <img class="logo" :src="logo" alt="">
            <p class="title">{{ title }}</p>
        </div>
        <p class="login_title">修改密码</p>
        <div class="login-icon">
            <img src="../../assets/images/login/login-icon.png" alt="">
        </div>
        <van-cell-group>
            <van-field
            v-model="phone"
            placeholder="请输入手机号"
            >
            <van-icon slot="left-icon" class-prefix="iconfont" name="iconshouji" />
            </van-field>

            <van-field
            v-model="old_password"
            type="password"
            placeholder="请输入原密码"
            >
            <van-icon slot="left-icon" class-prefix="iconfont" name="iconmima" />
            </van-field>

            <van-field
            v-model="password	"
            type="password"
            placeholder="请输入新密码"
            >
            <van-icon slot="left-icon" class-prefix="iconfont" name="iconmima" />
            </van-field>

            <van-field
            v-model="password_confirmation	"
            type="password"
            placeholder="请确认新密码"
            >
            <van-icon slot="left-icon" class-prefix="iconfont" name="iconmima" />
            </van-field>

      </van-cell-group>
      <div class="btns">
        <div class="btn-login" @click="updatePassword">修改密码</div>
        <div class="btn-login" @click="$router.go(-1)">返回</div>
      </div>
      </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'updatePwd',
  data(){
    return {
      phone: '', // 手机号 
      old_password: '', // 旧密码
      password: '', // 新密码
      password_confirmation: '', // 确认新密码
      logo: '', // 默认logo
      title: '',
    }
  },
  components: {},
  mounted(){},
  methods: {
    // 重置密码
    updatePassword () {
      let data = new FormData()
      data.append('phone', this.phone)
      data.append('old_password', this.old_password)
      data.append('password', this.password)
      data.append('password_confirmation', this.password_confirmation)
      this.util.post(this.api.updatePassword, data, (success) => {
        Toast('修改密码成功')
        this.$router.push('/login')
      })
    }
  }
}
</script>
<style lang='scss'>
@import "../../assets/scss/functions";
.updatePwd {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/login/login-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  .login_box {
    width: pxToRem(500px);
    position: absolute;
    /*top: 50%;*/
    top: 8%;
    left: 50%;
    /*margin-top: pxToRem(-500px);*/
    margin-left: pxToRem(-250px);

    .login_logo_box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: pxToRem(100px);

      .logo {
        width: pxToRem(90px);
        margin-right: pxToRem(30px);
      }

      .title {
        color: #fff;
        font-size: pxToRem(35px);
        letter-spacing: 2px;
        font-weight: 500;
      }
    }

    .login_title {
      text-align: center;
      font-size: pxToRem(45px);
      letter-spacing: 1px;
      color: #fff;
      margin-bottom: pxToRem(30px);
      font-weight: 500;
    }

    .login-icon {
      text-align: center;
      margin-bottom: pxToRem(40px);

      img {
        width: pxToRem(48px);
      }
    }

    .icon-code {
      width: 0.67rem;
    }

    .btns {
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
    }

    .btn-login {
      width: 40%;
      padding: pxToRem(15px) pxToRem(20px);
      background:linear-gradient(-90deg,rgba(31,112,163,1),rgba(31,88,146,1));
      box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.25);
      border-radius: pxToRem(50px);
      text-align: center;
      color: #fff;
      letter-spacing: 2px;
      font-size: pxToRem(30px);
      font-weight: 500;
    }

    .van-cell-group, .van-cell, .van-field__control {
      background-color: transparent;
      color: #fff;
    }

    .van-field__control::-webkit-input-placeholder {
      color: #fff;
      font-size: pxToRem(20px);
    }

    .iconfont {
      font-size: pxToRem(50px);
      vertical-align: middle;
    }

    .van-cell {
      background:rgba(0, 0, 0, 0.3);
      margin-bottom: pxToRem(60px);
      border: pxToRem(1px) solid rgba(255, 255, 255, 1);
      border-radius: pxToRem(50px);
      padding: pxToRem(10px) pxToRem(20px);
      line-height: inherit;
    }
    
    .getCaptcha {
      float: right;
      margin: pxToRem(10px) pxToRem(20px) pxToRem(10px) 0;
    }

    .van-cell:not(:last-child)::after {
      border-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/updatePassword.vue